module.exports = __webpack_public_path__ + "img/ios.8feae191.png";